import React from "react";
import "./drops.css";
const Drops = () => {
  return (
    <div className="drops">
      <div className="drop"></div>
      <div className="drop"></div>
      <div className="drop"></div>
    </div>
  );
};

export default Drops;
